<p-dropdown (onChange)="statusChange($event.value)" [options]="statuses" [(ngModel)]="status" placeholder="Select a Status" optionLabel="title"></p-dropdown>